import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, errMsg, todayRome } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/common";

const EMPTY = { date: todayRome(), orario: "", owner_name: "", owner_phone: "", pickup_address: "", city: "", pet_name: "", species: "", notes: "" };

export const RiconsegnaDialog = ({ open, onOpenChange, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ ...EMPTY, date: todayRome() }); }, [open]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));
  const save = async () => {
    if (!f.date || !f.pickup_address.trim()) return toast.error("Giorno e indirizzo sono obbligatori");
    setBusy(true);
    try {
      await api.post("/admin/bookings", { ...f, kind: "riconsegna", service_type: "singola" });
      toast.success("Riconsegna aggiunta in agenda"); onSaved?.(); onOpenChange(false);
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-[#FAF8F5] max-h-[90vh] overflow-y-auto" data-testid="riconsegna-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-[#0D3B52]">Nuova riconsegna</DialogTitle>
          <DialogDescription>Appuntamento di riconsegna urna: compare in agenda nel giorno scelto con l'orario.</DialogDescription>
        </DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Giorno *"><Input type="date" value={f.date} onChange={set("date")} className="bg-white" data-testid="ric-date" /></Field>
          <Field label="Orario"><Input type="time" value={f.orario} onChange={set("orario")} className="bg-white" data-testid="ric-orario" /></Field>
          <Field label="Nome proprietario"><Input value={f.owner_name} onChange={set("owner_name")} className="bg-white" data-testid="ric-owner" /></Field>
          <Field label="Telefono"><Input value={f.owner_phone} onChange={set("owner_phone")} className="bg-white" data-testid="ric-phone" /></Field>
          <Field label="Indirizzo di riconsegna *"><Input value={f.pickup_address} onChange={set("pickup_address")} className="bg-white" data-testid="ric-address" /></Field>
          <Field label="Città"><Input value={f.city} onChange={set("city")} className="bg-white" /></Field>
          <Field label="Nome animale"><Input value={f.pet_name} onChange={set("pet_name")} className="bg-white" data-testid="ric-pet" /></Field>
          <Field label="Specie"><Input value={f.species} onChange={set("species")} className="bg-white" /></Field>
          <Field label="Note" className="sm:col-span-2"><Textarea rows={2} value={f.notes} onChange={set("notes")} className="bg-white" /></Field>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-full">Annulla</Button>
          <Button onClick={save} disabled={busy} data-testid="ric-save" className="rounded-full bg-[#0D3B52] hover:bg-[#082535]">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salva riconsegna"}</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
